import React, { useState, useEffect } from 'react';
import { TListingGallery } from 'types/TListing';

type TUseCarousel = {
  imageUrls: TListingGallery['imageUrls'];
  imageSizes?: TListingGallery['media']['imageSizes'];
  toggleCarouselModal: TCarouselIndexHandler;
  alt: string;
  changeCarouselIndex: TCarouselIndexHandler;
};

type TCarouselIndexHandler = (index: number) => void;

type TGalleryCarouselProps = {
  index: number;
};

type TModalCarouselProps = TGalleryCarouselProps & {
  imageUrls: TListingGallery['imageUrls'];
  onChangeHandler: TCarouselIndexHandler;
};

let ModalCarousel: React.ComponentType<TModalCarouselProps> | undefined;
let GalleryCarousel: React.ComponentType<TGalleryCarouselProps> | undefined;

const useCarousel = ({ imageUrls, imageSizes, toggleCarouselModal, alt, changeCarouselIndex }: TUseCarousel) => {
  const [showCarousel, setShowCarousel] = useState(false);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        const CarouselWrapper = (await import(/* webpackChunkName: "carousel" */ '../CarouselWrapper')).default;

        const carouselGallery = ({ index }: TGalleryCarouselProps) => (
          <CarouselWrapper
            onClickItemHandler={toggleCarouselModal}
            imageUrls={imageUrls}
            imageSizes={imageSizes}
            onChangeHandler={changeCarouselIndex}
            index={index}
            alt={alt}
          />
        );

        const carouselModal = ({ index, imageUrls: modalImageUrls, onChangeHandler }: TModalCarouselProps) => (
          <CarouselWrapper
            isModal={true}
            imageUrls={modalImageUrls}
            onChangeHandler={onChangeHandler}
            index={index}
            alt={alt}
          />
        );

        GalleryCarousel = carouselGallery;
        ModalCarousel = carouselModal;

        setShowCarousel(imageUrls.length > 1);
      } catch {}
    };

    loadComponent();
  }, [imageUrls.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    ModalCarousel,
    GalleryCarousel,
    showCarousel,
  };
};

export default useCarousel;
